/**
 * sessionStorage flag set by the reseller identifier-first page (`/unified_login/identifier`) right
 * before it hands off to `/unified_login/start`, and read + cleared by `start.tsx`, which passes
 * `fromReseller` into `loginWithIdP`. That marker rides in `appState` through the IdP round-trip
 * so a failed teammate-accept reroutes back to the reseller page instead of the legacy
 * `/login/identifier`. It is NOT a moved query param (it never appears in a URL). (CLRF-2268)
 */
export const RESELLER_FLOW_FLAG = "reseller_flow";

/** Changelog entry explaining the marketplace unified login change; linked from the identifier page. */
export const MARKETPLACE_CHANGELOG_URL =
  "https://www.twilio.com/en-us/changelog/unified-login-for-sendgrid-marketplace-customers";
